export const CURRICULUM_OPTIONS = [
  'CBSE',
  'ICSE',
  'IB',
  'SSC',
  'State Board',
] as const;

export type CurriculumOption = (typeof CURRICULUM_OPTIONS)[number];
